import Vue from 'vue';
import { conversationPreview, formatTime, isUnread, studentName } from '../utils';
export default Vue.extend({
    name: 'GlobalCommbookList',
    props: {
        records: { type: Array, default: function () { return []; } },
        readFilter: { type: String, default: 'UNREAD' },
        selectedId: { type: String, default: '' },
        total: { type: Number, default: 0 },
        hasMore: Boolean,
        loadingMore: Boolean,
        loadMoreError: { type: String, default: '' },
        resetKey: { type: String, default: '' },
        hasLocation: Boolean,
        loading: Boolean,
        error: { type: String, default: '' },
        actionError: { type: String, default: '' },
        canRetryRead: Boolean,
        bulkReading: Boolean,
        starBusy: { type: Object, default: function () { return ({}); } }
    },
    data: function () {
        return {
            filters: [
                { label: 'Unread', value: 'UNREAD' },
                { label: 'All', value: 'ALL' }
            ]
        };
    },
    watch: {
        resetKey: function () {
            var _this = this;
            this.$nextTick(function () {
                var list = _this.$refs.listScroll;
                if (list)
                    list.scrollTop = 0;
                _this.checkLoadMore();
            });
        },
        records: function () {
            var _this = this;
            this.$nextTick(function () { return _this.checkLoadMore(); });
        },
        loading: function (value) {
            var _this = this;
            if (!value)
                this.$nextTick(function () { return _this.checkLoadMore(); });
        },
        loadingMore: function (value) {
            var _this = this;
            if (!value)
                this.$nextTick(function () { return _this.checkLoadMore(); });
        }
    },
    methods: {
        name: studentName,
        unread: isUnread,
        time: formatTime,
        preview: conversationPreview,
        hasTitle: function (record) {
            return !!String(record.title || '').trim();
        },
        isStaffMessage: function (record) {
            return [1, 2].includes(Number(record.latestMessageSenderType));
        },
        onScroll: function () {
            this.checkLoadMore();
        },
        checkLoadMore: function () {
            if (!this.hasMore ||
                this.loading ||
                this.loadingMore ||
                this.error ||
                this.loadMoreError ||
                !this.records.length)
                return;
            var list = this.$refs.listScroll;
            if (list && list.scrollHeight - list.scrollTop - list.clientHeight <= 120) {
                this.$emit('load-more');
            }
        }
    }
});
